import { useState, useEffect } from "react";
import { FileClock } from "lucide-react";
import DataTable from "@/components/DataTable";
import { Button } from "@/components/ui/button";
import { useParams, useNavigate } from "react-router-dom";
import { getUserTransactions } from "@/api/transactions";
import { getApplications } from "@/api/application";
import { getUserById } from "@/api/auth";

const columns = [
  { header: "İşlem ID", accessor: "id" },
  { header: "Kullanıcı ID", accessor: "user_id" },
  { header: "Uygulama ID", accessor: "app_id" },
  { header: "Cüzdan Adresi", accessor: "wallet_address" },
  { header: "İşlem", accessor: "process" },
  { header: "Tutar", accessor: "amount" },
  { header: "Tarih", accessor: "date" },
];

export default function UserTransactionHistory() {
  const { appId, userId } = useParams();
  const navigate = useNavigate();
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [userInfo, setUserInfo] = useState(null);
  const [appInfo, setAppInfo] = useState(null);

  useEffect(() => {
    setLoading(true);
    getUserTransactions(userId)
      .then((response) => {
        const txs = Array.isArray(response.data)
          ? response.data
          : response.data?.body?.result || response.data?.body || [];
        setTransactions(txs);
        setError("");
      })
      .catch((err) => setError("İşlem verileri alınamadı."))
      .finally(() => setLoading(false));

    getUserById(userId)
      .then((response) => {
        const user = response.data || {};
        setUserInfo(
          user.first_name
            ? { name: `${user.first_name} ${user.last_name}` }
            : { name: `Kullanıcı #${userId}` }
        );
      })
      .catch(() => setUserInfo({ name: `Kullanıcı #${userId}` }));

    getApplications()
      .then((response) => {
        const appsArr = Array.isArray(response.data)
          ? response.data
          : response.data?.body?.result || response.data?.body || [];
        const app = appsArr.find((a) => a.id === parseInt(appId));
        setAppInfo(app ? { name: app.name } : { name: `Uygulama #${appId}` });
      })
      .catch(() => setAppInfo({ name: `Uygulama #${appId}` }));
  }, [appId, userId]);

  const handleRefresh = () => window.location.reload();

  const sortedTransactions = [...transactions].sort(
    (a, b) => new Date(b.date) - new Date(a.date)
  );

  const handleGoBack = () => {
    navigate(`/applicationmanagement/${appId}/users`);
  };

  if (loading) return <div className="p-6 ml-8">Yükleniyor...</div>;
  if (error) return <div className="p-6 ml-8 text-red-500">{error}</div>;

  return (
    <div className="p-6 ml-8">
      <div className="flex justify-between items-center mb-6">
        <div className="flex items-center gap-4">
          <Button variant="left-icon" size="icon" onClick={handleGoBack} />
          <div className="flex items-center gap-3">
            <FileClock />
            <h1 className="text-2xl font-bold">
              {userInfo?.name} - İşlem Geçmişi ({appInfo?.name})
              {userInfo?.email && (
                <span className="ml-4 text-base text-gray-500">
                  {userInfo.email}
                </span>
              )}
            </h1>
          </div>
        </div>
        <Button variant="refresh" onClick={handleRefresh} />
      </div>

      {transactions.length === 0 ? (
        <div className="flex items-center justify-center p-8 bg-gray-50 rounded-lg">
          <p className="text-gray-500">
            Bu kullanıcının henüz işlem geçmişi bulunmuyor.
          </p>
        </div>
      ) : (
        <DataTable
          data={sortedTransactions}
          columns={columns}
          caption={`${userInfo?.name} için geçmiş işlemler listesi`}
          itemsPerPage={5}
          isAddButtonEnabled={false}
        />
      )}
    </div>
  );
}
